import Button from '@jetbrains/ring-ui/components/button/button'
import classNames from 'classnames'
import type {ChangeEvent} from 'react'
import * as React from 'react'

import Search from '../../../components/Search/Search'

import styles from './LeanFilter.css'

export default function Filter({
  query,
  onChange,
  onClear,
  id,
  className,
}: {
  query: string
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
  onClear: () => void
  id: string
  className?: string | undefined
}): React.ReactElement {
  const [show, setShow] = React.useState(false)
  const onShow = React.useCallback(() => setShow(true), [setShow])
  const onReset = React.useCallback(() => {
    setShow(false)
    onClear()
  }, [setShow, onClear])
  const inputRef = React.useRef<HTMLInputElement>(null)
  React.useEffect(() => {
    if (inputRef.current != null) {
      inputRef.current.focus()
    }
  })

  return show ? (
    <div className={classNames(className, styles.filter)}>
      <Search
        forwardedRef={inputRef}
        className={styles.input}
        onChange={onChange}
        onClear={onReset}
        id={id}
        value={query}
        placeholder={'Filter...'}
      />
      <Button className={styles.hideButton} onClick={onReset}>
        {'Reset'}
      </Button>
    </div>
  ) : (
    <Button className={className} onClick={onShow}>
      {'Filter...'}
    </Button>
  )
}
